/**
 * @desc 导出出口报关单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.exportDeclaration.exportExportDeclarationReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/exportExportDeclarationReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
